import requests from './requests'
import { request } from 'https';

const Auth = {
  login: (email, password) => requests.post('/crm/login', { email, password }, true),
  //TODO: remove
  loginEasymillions: (username, password) => requests.post('easymillions/login', {
    "username": username,
    "password": password
}, true)
}

const firstElement = arr => arr[0]

const Testimonials = {
  getAll: () => requests.get('/frontend_testimonial/testimonials')
}

const FAQ = {
  getAll: () => requests.get('/frontend_faq/faqs')
}

const Pages = {
  getAll: () => requests.get('/frontend_page/pages'),
  byAlias: (alias) => requests.get('/frontend_page/pages', {alias}).then(firstElement)
}

const Favorites = {
  getAll: () => requests.get('/cashback/my/customer', {
    populate: 'favoriteCategories',
  }),
  putFavoriteCategories: (favoriteCategories) => {
    return requests.put('/cashback/my/customer', {
      favoriteBrands: [], favoriteCategories,
    })
  }
}

const Categories = {
  getAll: () => requests.get('/cashback/categories', {
    active: true,
    sort: 'title',
    fields: 'title alias headerImage parent'
  })
}

const Brands = {
  getAll: () => requests.get('/cashback/brands', {
    fields: 'title alias logoImage url minimumCommission minimumCommissionPercent maximumCommission maximumCommissionPercent',
    active: true,
    populate: 'cashback_categories',
    ignore: false
  }),
  bySearch: (searchTerm) => requests.get('/cashback/brands', {
    search: (searchTerm === 'all') ? undefined : searchTerm,
    fields: 'title alias logoImage url minimumCommission minimumCommissionPercent maximumCommission maximumCommissionPercent',
    active: true,
    ignore: false
  })
}

const Translations = {
  getAll: () => requests.get('/frontend_translation/translations'),
  missingTranslation: (key) => {}//requests.post('/frontend_translation/missingtranslations', {key})
}

const User = {
  getCustomer: () => requests.get('/cashback/my/customer', {populate: 'crm_customer', fields: 'crm_customer balance bankOwner bankIban bankBic paypalOwner paypalEmail newsletterNews newsletterBrand newsletterSpecial favoriteCategories favoriteBrands'}),
  getPayoffs: () => requests.get('/cashback/my/payoffs', {populate: 'cashback_customer', fields: 'payoffId status amount cashback_customer type bankOwner bankIban bankBic paypalOwner paypalEmail createdAt'}),
  getTransactions: () => requests.get('/cashback/my/transactions', {populate: 'cashback_brand cashback_customer', fields: 'transactionId cashback_brand cashback_customer orderId price commission cashback status createdAt'}),
  createCustomer: (body) => requests.post('/crm/customers', body),
  confirmCustomer: (body) => requests.put('/crm/customer/confirm', body),
  confirmChangeEmail: (confirmationId) => requests.put('/crm/external/customer', {'action': 'change_email', 'confirmationId': confirmationId}),
  getLead: (id) => requests.get('/easyplus_fr/leads/confirm/' + id),
  changePassword: (newPassword) => requests.put('/crm/my/customer', {'action': 'change_password', 'password': newPassword}),
  passwordRecover: (email, altcha) => requests.put('/crm/external/customer', {'action': 'forgot_password', 'email': email, 'altcha': altcha}),
  setPassword: (confirmId, password) => requests.put('/crm/external/customer', {'action': 'set_password', 'confirmationId': confirmId, 'password': password}),
  deactivateAccount: () => requests.put('crm/my/customer', {'action': 'deactivate'}),
  terminateAccount: () => requests.put('/easyplus_de/terminate'),
  reactivateAccount: (confirmationId) => requests.put('/crm/external/customer', {'action': 'reactivate', confirmationId}),
  changeEmail: (newEmail) => requests.put('/crm/my/customer', {'action': 'change_email', 'changeEmailValue': newEmail}),
  updateNewsletterSubscription: ({newsletterBrand, newsletterNews, newsletterSpecial}) => requests.put('/cashback/my/customer', {newsletterBrand, newsletterNews, newsletterSpecial}),
  updateCashbackCustomer: (cashbackCustomer) => requests.put('/cashback/my/customer', {...cashbackCustomer}),
  postCashbackPayoff: (body) => requests.post('/cashback/my/payoffs', body),
  updateCustomer: (body) => requests.put('/crm/my/customer', body),
  resendConfirmationEmail: (confirmationId) => requests.put('/crm/customer/resendconfirmation', {'confirmationId': confirmationId}),
  unsubscribeEmail: (email) => requests.get('/email/mail/unsubscribe/' + email),
  leadConfirm: (body) => requests.put('/easyplus_fr/leads/confirm', body),
  checkOngoingmediaCode: (code) => requests.put('/easyplus_de/ongoingmedialeads/checkCode', {...code}),
  createOngoingmediaCustomer: (body) => requests.post('easyplus_de/ongoingmedialeads/customers', body),
  createCodeCustomer: (body) => requests.post('easyplus_de/customers', body),
  confirmAccount: (body) => requests.post('/easyplus_de/confirm-customer', body),
  // not tested
  // update: (user) => requests.put('/my/cashbackcustomer', user)
}

const Config = {
  getMinimumPayoffAmount: () => requests.get('/cashback/configs/minimumpayoffamount')
}

const Contact = {
  postContactRequest: (body) => requests.post('/contact/requests', body)
}

const BonusPlan = {
  getRegistrationcode: (id) => requests.get('/bonusplan24/registrationcode/' + id),
  putRegistrationcode: (id) => requests.put('/bonusplan24/registrationcode/' + id, {'used': true})
}

export default {
  Pages,
  Auth,
  Categories,
  Translations,
  User,
  FAQ,
  Brands,
  Favorites,
  Testimonials,
  Config,
  Contact,
  BonusPlan,
}



// WEBPACK FOOTER //
// ./src/api/index.js